import React, { useEffect, useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import searchIcon from "../../../assets/magnifyingglass-search.svg";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSearchParams } from "react-router-dom";

const SearchDiv = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: 10,
  display: "flex",
  flexDirection: "row",
  padding: "0px 8px",
  /*  backgroundColor: "rgba(250, 250, 250, 0.93)",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  }, */
  color: "#8EB3C1",
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("md")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
    border: "none",
  },
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
    border: "none",
  },
  [theme.breakpoints.down("sm")]: {
    width: "auto",
    border: "1px solid grey",
    borderRadius: "50px",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "20px",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "rgba(60, 60, 67, 0.6)",
  fontFamily: "Poppins Regular",
  width: "100%",
  padding: "0px 8px",
  borderBottom: "1px solid rgba(60, 60, 67, 0.6)",
  "& .MuiInputBase-input": {
    color: "#3d3b3b",

    textAlign: "left",
    fontFamily: "Poppins Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "22px",
    padding: theme.spacing(0.5, 0.5, 0.5, 0),

    // vertical padding + font size from searchIcon
   // paddingRight: `calc(1em + ${theme.spacing(4)})`, //spacing(0.2)
    transition: theme.transitions.create("width"),

    [theme.breakpoints.up("xs")]: { width: "100%" },
    [theme.breakpoints.up("sm")]: { width: "100%" },
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(0.5, 0.5, 0.5, 3),
    width: "100%",
    borderBottom: "none",
  },
}));
type Props = {
  SearchText: string;
  handleSearch: CallableFunction;
  handleClose?: CallableFunction;
};

const Search: React.FC<Props> = (props) => {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("query"); // Retrieve the query parameter

  const [query, setQuery] = useState<string>(searchQuery || "");
  const [isFocused, setIsFocused] = useState<boolean>(false);

  /* 
  useEffect(() => {
    if (query.length > 2 || query.length === 0) props.handleSearch(query);
  }, [props]);
 */

  useEffect(() => {}, [query]);
  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setQuery(event.currentTarget.value);
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && query.trim()) {
      props?.handleSearch(query);
    }
  };
  return (
    <div>
      <SearchDiv>
        <SearchIconWrapper>
          <img src={searchIcon} alt={"Search Icon"} />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder={
            isFocused ? "ex: apple iphone 15 128gb" : "Search for products"
          }
          inputProps={{ "aria-label": "search" }}
          value={query}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          id="product-search-input"
        />
        <IconButton
          disableFocusRipple
          disableRipple
          //disabled={query.length < 10}
          sx={{
            flexGrow: 1,
            //  mr: 1,
            marginLeft: "auto",
            display: { xs: "none", sm: "block", md: "block" },
            "&:hover": { backgroundColor: "transparent" },
          }}
          //    onClick={() => props.handleSearch(query)}
          onClick={() => props?.handleClose && props.handleClose()} // Call handleClose explicitly
          key={"pp-web-search-close-icon"}
          id="product-search-close-icon-button"
        >
          <CloseIcon style={{ height: "16px" }} />
        </IconButton>
      </SearchDiv>
    </div>
  );
};

export default Search;
